<mat-form-field [formGroup]="group" class="input" appearance="outline">
  <mat-label>{{ config.label }}</mat-label>
  <textarea #input matInput class="uppercase" [formControlName]="config.name" [attr.rows]="config.rows || 6"
    [attr.maxlength]="config.maxLength || null"
    [attr.placeholder]="config.placeholder"
    (focus)="keyboardService.onInputFocus(keyboardChange, $event)"
    (ngModelChange)="keyboardService.onInputChange(group.getRawValue(), input)"></textarea>
  <!-- <mat-error *ngIf="group.get(config.name)?.touched && group.get(config.name)?.hasError('required')">
    <span>Campo Obrigatório</span>
  </mat-error> -->
</mat-form-field>
